export const publicReimbursementMoreInfoPtBr = {
  pageTitle: 'Acompanhe seu pedido',
  pageSubtitle:
    'Veja o andamento do seu reembolso, acompanhe as mensagens e confira se existe alguma ação pendente.',
  requestStatus: {
    submitted: 'Sistema · pedido recebido',
    systemPolicyReview: 'IA · avaliando política',
    awaitingYourResponse: 'Sua ação · enviar informações',
    awaitingManager: 'Gestor · análise em andamento',
    approved: 'Aprovado',
    rejected: 'Recusado',
    convertedToBill: 'Sistema · em pagamento',
    cancelledByRequester: 'Cancelado por você',
  },
  trackingSelfService: {
    title: 'Corrigir ou atualizar seu pedido',
    description:
      'Enquanto o gestor ainda não aprovou o reembolso, você pode ajustar os dados, enviar comprovantes adicionais ou cancelar o pedido.',
    save: 'Salvar alterações',
    saveWithFiles: 'Salvar e enviar arquivos',
    cancelRequest: 'Cancelar pedido',
    cancelDialogTitle: 'Cancelar este pedido de reembolso?',
    cancelDialogDescription:
      'O pedido será retirado da fila de análise. Esta ação não pode ser desfeita pelo portal.',
    cancelDialogConfirm: 'Sim, cancelar pedido',
    cancelDialogDismiss: 'Voltar',
    cancellationNoteLabel: 'Motivo do cancelamento (opcional)',
    cancellationNotePlaceholder: 'Ex.: anexei o comprovante errado.',
  },
  loading: 'Carregando seu pedido...',
  managerMessageLabel: 'Mensagem do gestor',
  requestedByLabel: 'Solicitado por',
  expiresAtLabel: 'O link expira em',
  noEntityLabel: 'Sem empresa associada',
  pendingInfoRequest: {
    title: 'O gestor solicitou mais informações',
    description:
      'Leia a mensagem abaixo, complete ou corrija os dados solicitados e envie sua resposta para continuar a análise.',
  },
  receiptAlerts: {
    title: 'Revise seus comprovantes',
    description:
      'A análise automática dos anexos apontou os itens abaixo. Corrija o pedido ou envie comprovantes adicionais enquanto o gestor ainda não aprovou.',
    codes: {
      RECEIPT_TOTAL_EXCEEDS_REQUESTED:
        'O valor total do comprovante é maior que o valor que você solicitou para reembolso. Confira se o valor solicitado está correto.',
      REQUESTER_NAME_MISSING_ON_RECEIPT:
        'O comprovante não mostra claramente o nome do beneficiário (você). Envie um documento em que seu nome apareça ou ajuste os dados do pedido.',
      REQUESTER_NAME_MISMATCH_ON_RECEIPT:
        'O nome no comprovante não coincide com o solicitante deste pedido. Verifique se anexou o arquivo correto ou atualize os dados.',
    },
  },
  messageHistory: {
    title: 'Histórico da conversa',
    description: 'Acompanhe as mensagens trocadas sobre este pedido de informação.',
    managerRole: 'Gestor',
    requesterRole: 'Solicitante',
    managerFallback: 'Gestor',
    requesterFallback: 'Você',
    managerInitial: 'G',
    requesterInitial: 'S',
    changedFieldsLabel: 'Campos atualizados',
    attachmentsAdded_one: '{{count}} comprovante adicionado',
    attachmentsAdded_other: '{{count}} comprovantes adicionados',
    noMessage: 'Atualização enviada sem mensagem adicional.',
    changedFields: {
      description: 'descrição',
      businessJustification: 'justificativa de negócio',
      expenseClassification: 'categoria',
      merchantName: 'estabelecimento',
      merchantTaxId: 'CNPJ do estabelecimento',
      pixKey: 'chave Pix',
    },
  },
  timeline: {
    title: 'Histórico da solicitação',
    description: 'Acompanhe somente as etapas importantes deste pedido.',
    actorLabel: 'Responsável',
    approvedAmountLabel: 'Valor aprovado',
    expectedPaymentDateLabel: 'Data prevista',
    events: {
      REQUEST_SUBMITTED: 'Solicitação enviada',
      POLICY_EVALUATED: 'Solicitação recebida e avaliada automaticamente',
      AMOUNT_ADJUSTED: 'Valor ajustado conforme a política',
      INFO_REQUESTED: 'Gestor solicitou informações',
      INFO_RESPONDED: 'Informações enviadas',
      APPROVED: 'Solicitação aprovada',
      REJECTED: 'Solicitação reprovada',
      CONVERTED_TO_BILL: 'Solicitação enviada para pagamento',
      UPDATED: 'Solicitação avaliada pelo gestor',
      CANCELLED: 'Solicitação cancelada',
    },
  },
  blocked: {
    expired: {
      title: 'Este link expirou',
      description:
        'O link de resposta venceu. Entre em contato com o gestor para solicitar um novo envio.',
    },
    revoked: {
      title: 'Link inválido',
      description: 'Este link foi revogado ou já não pode ser utilizado.',
    },
    already_responded: {
      title: 'Resposta já enviada',
      description:
        'Você já enviou as informações solicitadas. O gestor receberá uma atualização e dará o retorno em breve.',
    },
    converted_to_bill: {
      title: 'Pedido já em pagamento',
      description:
        'Este reembolso já foi convertido em uma fatura e não aceita mais alterações pelo portal.',
    },
    already_approved: {
      title: 'Pedido já aprovado',
      description:
        'Este reembolso já foi aprovado pelo gestor; não há mais necessidade de complemento.',
    },
    already_rejected: {
      title: 'Pedido recusado',
      description: 'Este reembolso foi recusado pelo gestor. Entre em contato em caso de dúvidas.',
    },
    cancelled: {
      title: 'Pedido de informação cancelado',
      description: 'O gestor cancelou este pedido de informação. Aguarde uma nova mensagem.',
    },
    cancelled_by_requester: {
      title: 'Pedido cancelado por você',
      description:
        'Este reembolso foi cancelado pelo portal. Se precisar reenviar, faça uma nova solicitação.',
    },
    fallback: {
      title: 'Não é possível responder agora',
      description:
        'O pedido não está mais em condição de receber novas informações pelo portal. Procure o gestor para mais detalhes.',
    },
  },
  fields: {
    requesterName: 'Solicitante',
    requesterEmail: 'E-mail do solicitante',
    requesterCpfCnpj: 'CPF/CNPJ do solicitante',
    expenseDate: 'Data da despesa',
    totalAmount: 'Valor total',
    requestedAmount: 'Valor solicitado',
    reimbursementDueDate: 'Data prevista para reembolso',
    description: 'Descrição',
    businessJustification: 'Justificativa de negócio',
    expenseClassification: 'Categoria do reembolso',
    merchantName: 'Estabelecimento',
    merchantTaxId: 'CNPJ do estabelecimento',
    pixKey: 'Chave Pix para recebimento',
    responseNote: 'O que mudou nesta resposta? (opcional)',
  },
  placeholders: {
    description: 'Conte ao gestor o que foi essa despesa',
    businessJustification: 'Justifique o motivo da despesa para a empresa',
    expenseClassification: 'Ex.: Marketing, Hospedagem...',
    merchantName: 'Nome do estabelecimento',
    merchantTaxId: '00.000.000/0000-00',
    pixKey: 'CPF, e-mail, telefone ou chave aleatória',
    responseNote: 'Explique brevemente o que foi corrigido ou enviado.',
  },
  submissionSummary: {
    title: 'Envio com vários pedidos',
    description:
      'Você enviou {{count}} pedidos de reembolso de uma vez. Abaixo está o resumo de cada um e o total do envio.',
    currentBadge: 'Pedido desta página',
    totalRequested: 'Total solicitado no envio',
    totalReceipt: 'Total das notas no envio',
    trackRequest: 'Acompanhar pedido {{index}}',
  },
  sections: {
    summary: 'Resumo do pedido',
    summaryBatchTitle: 'Resumo do envio ({{current}} de {{total}})',
    summaryBatchHint:
      'Os valores abaixo referem-se a este pedido. O total de todos os pedidos enviados juntos aparece em destaque.',
    summaryBatchTotalRequested: 'Total solicitado no envio',
    summaryBatchTotalReceipt: 'Total das notas no envio',
    editable: 'Complete ou corrija os dados',
    editableDescription:
      'Responda a mensagem do gestor e ajuste somente os campos que precisam de correção.',
    attachments: 'Comprovantes',
    addAttachments: 'Enviar comprovantes adicionais',
  },
  attachmentsHelp:
    'Você pode anexar arquivos adicionais (PDF, JPG ou PNG, até 10 MB cada). Eles serão enviados ao gestor após você responder.',
  existingAttachmentsEmpty: 'Nenhum comprovante anexado pelo solicitante até o momento.',
  buttons: {
    submit: 'Enviar resposta',
    submitWithFiles: 'Enviar resposta e anexar arquivos',
    sending: 'Enviando...',
    selectFiles: 'Selecionar arquivos',
    removeFile: 'Remover',
  },
  toasts: {
    submitted: 'Resposta enviada com sucesso.',
    updated: 'Alterações salvas com sucesso.',
    cancelled: 'Pedido cancelado.',
    uploadFailed: 'Resposta enviada, mas alguns anexos não puderam ser enviados.',
    updateUploadFailed: 'Alterações salvas, mas alguns anexos não puderam ser enviados.',
    error: 'Não foi possível enviar sua resposta. Tente novamente.',
    updateError: 'Não foi possível salvar suas alterações. Tente novamente.',
    cancelError: 'Não foi possível cancelar o pedido. Tente novamente.',
  },
  success: {
    title: 'Resposta enviada!',
    description:
      'Recebemos suas informações. O gestor será notificado e dará retorno assim que possível.',
    backToTop: 'Ver dados enviados',
  },
};

export const publicReimbursementMoreInfoEn = {
  pageTitle: 'Track your request',
  pageSubtitle:
    'Follow the progress of your reimbursement, review messages, and check whether any action is pending.',
  requestStatus: {
    submitted: 'System · request received',
    systemPolicyReview: 'AI · evaluating policy',
    awaitingYourResponse: 'Your action · send information',
    awaitingManager: 'Manager · review in progress',
    approved: 'Approved',
    rejected: 'Rejected',
    convertedToBill: 'System · payment in progress',
    cancelledByRequester: 'Cancelled by you',
  },
  trackingSelfService: {
    title: 'Correct or update your request',
    description:
      'While the manager has not approved the reimbursement yet, you can adjust details, upload additional receipts, or cancel the request.',
    save: 'Save changes',
    saveWithFiles: 'Save and upload files',
    cancelRequest: 'Cancel request',
    cancelDialogTitle: 'Cancel this reimbursement request?',
    cancelDialogDescription:
      'The request will be removed from review. This cannot be undone from the portal.',
    cancelDialogConfirm: 'Yes, cancel request',
    cancelDialogDismiss: 'Go back',
    cancellationNoteLabel: 'Reason for cancellation (optional)',
    cancellationNotePlaceholder: 'e.g. I attached the wrong receipt.',
  },
  loading: 'Loading your request...',
  managerMessageLabel: 'Manager message',
  requestedByLabel: 'Requested by',
  expiresAtLabel: 'Link expires on',
  noEntityLabel: 'No company associated',
  pendingInfoRequest: {
    title: 'The manager requested more information',
    description:
      'Read the message below, complete or correct the requested details, and send your response to continue the review.',
  },
  receiptAlerts: {
    title: 'Review your receipts',
    description:
      'Automatic analysis of your attachments flagged the items below. Update the request or upload additional receipts while the manager has not approved yet.',
    codes: {
      RECEIPT_TOTAL_EXCEEDS_REQUESTED:
        'The receipt total is higher than the amount you requested for reimbursement. Check that the requested amount is correct.',
      REQUESTER_NAME_MISSING_ON_RECEIPT:
        'The receipt does not clearly show the beneficiary name (you). Upload a document that includes your name or update the request details.',
      REQUESTER_NAME_MISMATCH_ON_RECEIPT:
        'The name on the receipt does not match the requester on this request. Verify you attached the correct file or update the details.',
    },
  },
  messageHistory: {
    title: 'Conversation history',
    description: 'Review the messages exchanged about this info request.',
    managerRole: 'Manager',
    requesterRole: 'Requester',
    managerFallback: 'Manager',
    requesterFallback: 'You',
    managerInitial: 'M',
    requesterInitial: 'R',
    changedFieldsLabel: 'Updated fields',
    attachmentsAdded_one: '{{count}} attachment added',
    attachmentsAdded_other: '{{count}} attachments added',
    noMessage: 'Update sent without an additional message.',
    changedFields: {
      description: 'description',
      businessJustification: 'business justification',
      expenseClassification: 'category',
      merchantName: 'merchant',
      merchantTaxId: 'merchant tax id',
      pixKey: 'PIX key',
    },
  },
  timeline: {
    title: 'Request history',
    description: 'Follow only the important steps for this request.',
    actorLabel: 'Owner',
    approvedAmountLabel: 'Approved amount',
    expectedPaymentDateLabel: 'Expected date',
    events: {
      REQUEST_SUBMITTED: 'Request submitted',
      POLICY_EVALUATED: 'Request received and automatically reviewed',
      AMOUNT_ADJUSTED: 'Amount adjusted according to policy',
      INFO_REQUESTED: 'Manager requested information',
      INFO_RESPONDED: 'Information sent',
      APPROVED: 'Request approved',
      REJECTED: 'Request rejected',
      CONVERTED_TO_BILL: 'Request sent to payment',
      UPDATED: 'Request reviewed by manager',
      CANCELLED: 'Request cancelled',
    },
  },
  blocked: {
    expired: {
      title: 'This link has expired',
      description: 'The response link has expired. Contact the manager to request a new one.',
    },
    revoked: {
      title: 'Invalid link',
      description: 'This link has been revoked or can no longer be used.',
    },
    already_responded: {
      title: 'Response already sent',
      description:
        'You have already sent the requested information. The manager will be notified and follow up shortly.',
    },
    converted_to_bill: {
      title: 'Already processed',
      description:
        'This reimbursement has already been converted into a bill and no longer accepts changes via the portal.',
    },
    already_approved: {
      title: 'Already approved',
      description:
        'This reimbursement has already been approved by the manager — no more info needed.',
    },
    already_rejected: {
      title: 'Already rejected',
      description: 'This reimbursement was rejected by the manager. Reach out for details.',
    },
    cancelled: {
      title: 'Info request cancelled',
      description: 'The manager cancelled this info request. Wait for a new message.',
    },
    cancelled_by_requester: {
      title: 'Request cancelled by you',
      description:
        'This reimbursement was cancelled from the portal. Submit a new request if you still need reimbursement.',
    },
    fallback: {
      title: 'Cannot respond right now',
      description:
        'The request is no longer in a state that accepts more info through the portal. Contact your manager for details.',
    },
  },
  fields: {
    requesterName: 'Requester',
    requesterEmail: 'Requester email',
    requesterCpfCnpj: 'Requester tax id',
    expenseDate: 'Expense date',
    totalAmount: 'Total amount',
    requestedAmount: 'Requested amount',
    reimbursementDueDate: 'Expected reimbursement date',
    description: 'Description',
    businessJustification: 'Business justification',
    expenseClassification: 'Expense category',
    merchantName: 'Merchant',
    merchantTaxId: 'Merchant tax id',
    pixKey: 'PIX key for payout',
    responseNote: 'What changed in this response? (optional)',
  },
  placeholders: {
    description: 'Tell the manager what this expense was for',
    businessJustification: 'Explain why the company needs to cover this expense',
    expenseClassification: 'e.g. Marketing, Travel...',
    merchantName: 'Merchant name',
    merchantTaxId: '12-3456789',
    pixKey: 'Tax id, email, phone or random key',
    responseNote: 'Briefly explain what was fixed or sent.',
  },
  submissionSummary: {
    title: 'Multi-request submission',
    description:
      'You submitted {{count}} reimbursement requests at once. Below is each request and the batch total.',
    currentBadge: 'This page',
    totalRequested: 'Total requested in this submission',
    totalReceipt: 'Total receipt amount in this submission',
    trackRequest: 'Track request {{index}}',
  },
  sections: {
    summary: 'Request summary',
    summaryBatchTitle: 'Submission summary ({{current}} of {{total}})',
    summaryBatchHint:
      'The amounts below are for this request only. Batch totals for all requests submitted together are highlighted.',
    summaryBatchTotalRequested: 'Total requested in this submission',
    summaryBatchTotalReceipt: 'Total receipt amount in this submission',
    editable: 'Complete or correct the fields',
    editableDescription:
      'Reply to the manager message and adjust only the fields that need correction.',
    attachments: 'Attachments',
    addAttachments: 'Send extra attachments',
  },
  attachmentsHelp:
    'You can attach additional files (PDF, JPG or PNG, up to 10 MB each). They will be sent to the manager after you submit.',
  existingAttachmentsEmpty: 'No attachments uploaded by the requester yet.',
  buttons: {
    submit: 'Send response',
    submitWithFiles: 'Send response and attach files',
    sending: 'Sending...',
    selectFiles: 'Select files',
    removeFile: 'Remove',
  },
  toasts: {
    submitted: 'Response sent.',
    updated: 'Changes saved.',
    cancelled: 'Request cancelled.',
    uploadFailed: 'Response sent, but some files could not be uploaded.',
    updateUploadFailed: 'Changes saved, but some files could not be uploaded.',
    error: 'Could not send your response. Please try again.',
    updateError: 'Could not save your changes. Please try again.',
    cancelError: 'Could not cancel the request. Please try again.',
  },
  success: {
    title: 'Response sent!',
    description:
      'We received your information. The manager will be notified and follow up shortly.',
    backToTop: 'Review what you sent',
  },
};
